<style>
    h1 {
        text-transform: capitalize;
    }
</style>
<template>
    <div class="main-content">
        <section class="section">
          <div class="section-header">
            <h1>Pembayaran Penjualan Detail</h1>
            <div class="section-header-breadcumb button">
                <a href="javascript:" @click.prevent="goTo('/penjualan/print-invoice/'+id_transaksi_pembayaran)" class="btn btn-icon icon-left btn-primary"><i class="fas fa-file"></i> Cetak Invoice</a>
            </div>
          </div>
         <div class="section-body">
            <!-- <h2 class="section-title">Harga Total :$. {{ currencyFormat(transaksiDetail.detail.total_harga) }}</h2>
            <p class="section-lead">Dibayar : $. {{ currencyFormat(transaksiDetail.detail.dibayar) }} </p> -->
            <div class="row">
                <div class="col-12  col-md-6 col-lg-6">
                    <div class="card">
                        <div class="card-header">
                            <h4>Faktur List</h4>
                        </div>
                        <div class="card-body">
                            <table class="table table-hover">
                                <tr>
                                    <th>Nama Supplier : &nbsp; </th>
                                    <td> {{ detail.display_name }} </td>
                                </tr>
                            </table>
                            <table v-if="transaksiSelected.length > 0" class="table table-hover">
                                <thead>
                                    <th> Nomor - Nomor Surat Jalan </th>
                                    <th>&nbsp;</th>
                                </thead>
                                <tbody>
                                    <tr v-for="ts in transaksiSelected" :key="ts.id_transaksi">
                                        <td> {{ ts.nomor_pengiriman }} </td>
                                        <td><a :href="siteUrl+'Transaksi/getSuratJalanProgress/'+ts.id_transaksi_progress" target="_blank" class="btn btn-icon icon-left btn-light" style="margin-right:5px;"><i class="fas fa-truck"></i> Cetak Surat Jalan</a></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                    <div class="card">
                        <div class="card-header">
                            <h4>Informasi Invoice</h4>
                        </div>
                        <div class="card-body">
                            <table class="table table-striped">
                                <tbody>
                                    <tr>
                                        <th> Nomor Invoice : </th>
                                        <td> {{ detail.nomor_invoice }} </td>
                                    </tr>
                                    <tr>
                                        <th> Tanggal Invoice : </th>
                                        <td> {{ detail.tanggal_invoice_pembayaran | moment("DD MMMM YYYY") }} </td>
                                    </tr>
                                    <tr>
                                        <th> Tanggal Jatuh Tempo : </th>
                                        <td> {{ detail.tanggal_jatuh_tempo_pembayaran | moment("DD MMMM YYYY") }} </td>
                                    </tr>
                                    <tr>
                                        <th> Tanggal Pembayaran Terakhir : </th>
                                        <td> {{ detail.tanggal_pembayaran | moment("DD MMMM YYYY") }} </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h4>Daftar Produk</h4>
                        </div>
                        <div class="card-body">
                            <div class="table-responsive">
                                <table class="table table-striped">
                                    <tr>
                                        <td> 
                                            <p v-if="wilayah_penjualan == '0'"><b>Pembayaran Import</b></p>
                                            <p v-else><b>Pembayaran Dalam Negeri</b></p>
                                        </td>
                                        <th v-if="wilayah_penjualan == '0'" colspan="2" style="vertical-align:top">Kurs USD to IDR sekarang</th>
                                        <td v-if="wilayah_penjualan == '0'">
                                            <div class="form-group">
                                                <input disabled type="text" @change="countKurs()" class="form-control" v-model="kurs_usd"> 
                                            </div>
                                        </td> 
                                    </tr>
                                    <tr>
                                        <th>Produk</th>
                                        <th>Nomor Transaksi</th>
                                        <th>Kuantitas</th>
                                        <th>Satuan</th>
                                        <th v-if="isprice">Harga Satuan ($)</th>
                                        <th v-if="isprice">Harga Satuan (IDR)</th>
                                        <th v-if="isprice">Jumlah ($)</th>
                                        <th v-if="isprice">Jumlah (IDR)</th>
                                    </tr>
                                    <tbody v-if="bodyRender">
                                        <tr v-for="(data,index) in produkList" v-bind:key="index">
                                            <td>
                                            {{ data.transaksi_nama_produk }} 
                                            </td>
                                            <td>
                                                {{ data.nomor_transaksi }}
                                            </td>
                                            <td>
                                                {{ data.qty_send }}
                                            </td>
                                            <td>
                                                {{ data.nama_satuan }}
                                            </td>
                                            <td v-if="isprice">
                                                <div class="form-group">
                                                    <input type="text" disabled class="form-control" v-model="data.harga_satuan"> 
                                                </div>
                                            </td>
                                            <td v-if="isprice">
                                                <div class="form-group">
                                                    <input type="text" disabled class="form-control" v-model="data.harga_satuan_idr"> 
                                                </div>
                                            </td>
                                            <td v-if="isprice">
                                                <div class="form-group">
                                                    <input type="text" disabled class="form-control" v-model="data.harga_total"> 
                                                </div>
                                            </td>
                                            <td v-if="isprice">
                                                <div class="form-group">
                                                    <input type="text" disabled class="form-control" v-model="data.harga_total_idr"> 
                                                </div>
                                            </td>
                                            <td>
                                                <button class="btn btn-warning" @click="returnItem(data.id_transaksi_produk,data.id_transaksi_progress)"><i class="fa fa-undo"></i> Return</button>
                                            </td>
                                        </tr>
                                        <tr v-if="isprice">
                                            <th style="text-align:right" colspan="6">Sub Total Tagihan</th>
                                            <th>USD {{ currencyFormat(sub_total_tagihan) }}</th>
                                            <th>IDR {{ currencyFormat(sub_total_tagihan_idr) }} </th>
                                        </tr>
                                        <tr v-if="isprice" v-for="bl in biaya_lain">
                                            <th style="text-align:right;" colspan="6">
                                                {{ bl.nama_biaya }}
                                            </th>
                                            <th>
                                                {{ bl.jumlah_biaya }} {{ biayaIconCallback(bl.jenis_biaya) }}
                                            </th>
                                            <th>
                                                &nbsp;
                                            </th>
                                        </tr>
                                        <tr v-if="isprice">
                                            <th style="text-align:right" colspan="6">Total Tagihan</th>
                                            <th>USD {{ currencyFormat(total_tagihan) }}</th>
                                            <th>IDR {{ currencyFormat(total_tagihan_idr) }} </th>
                                            
                                        </tr>
                                        <tr v-if="isprice">
                                            <th colspan="6" style="text-align:right">Telah Dibayar</th>
                                            <th>
                                                USD {{ currencyFormat(dibayar) }} 
                                            </th>
                                            <th>
                                                IDR {{ currencyFormat(dibayar_idr) }} 
                                            </th>
                                        </tr>
                                        <tr v-if="detail.status_lunas == 0 && isprice">
                                            <th colspan="6" style="text-align:right">Akan Dibayar</th>
                                            <td>
                                                <div class="input-group">
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text">
                                                            <i class="fa fa-dollar"></i>
                                                        </div>
                                                    </div>
                                                    <input :disabled="disableUsd" type="text" @input="getDibayarIdr()" v-model="akan_dibayar" class="form-control"> 
                                                </div>
                                            </td>
                                            <td>
                                                <div class="input-group">
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text">
                                                            Rp.
                                                        </div>
                                                    </div>
                                                    <input :disabled="disableIdr" type="text" @input="getDibayarUsd()" v-model="akan_dibayar_idr" class="form-control"> 
                                                </div>
                                            </td>
                                        </tr>
                                        <tr v-if="akan_dibayar > 0 || akan_dibayar_idr > 0">
                                            <th colspan="6" style="text-align:right">Terima Pembayaran ke</th>
                                            <td colspan="2" style="text-align:center;vertical-align:middle;">
                                                <select id="akun_faktur" v-model="akun_bayar" class="form-control select2">
                                                        <option disabled value="">--Pilih Akun Bayar--</option>
                                                        <option v-for="option in akunBayarList" v-bind:key="option.id_coa" :value="option.id_coa">({{option.kode_akun}}) - {{ option.nama_akun}} ({{option.deskripsi}})</option>
                                                </select>
                                            </td>
                                        </tr>
                                        <tr v-if="isprice">
                                            <th style="text-align:right" colspan="6">Sisa Tagihan</th>
                                            <th>USD {{ currencyFormat(total_semua) }}</th>
                                            <th>IDR {{ currencyFormat(total_semua_idr) }} </th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 text-center">
                    <vc-date-picker v-model="tanggal_pembayaran" :input-props='{class: "form-control",placeholder: "Masukkan tanggal pembayaran",style:"display:inline;width:15%;"}'/>
                    <button v-if="detail.status_lunas == 0 && isprice" @click="submitPembayaran()" class="btn btn-primary"> <i class="fa fa-dollar"></i> Update Pembayaran</button>
                    <button v-if="detail.status_lunas == 1" @click="updateTanggalPembayaran()" class="btn btn-primary"> <i class="fa fa-calendar"></i> Update Tanggal Pembayaran</button>
                    <button @click="goBack()" class="btn btn-danger">Kembali</button>
                </div>
            </div>
        </div>
        </section>
    </div>
</template>
<style>
td {
    height: 30px;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import Vue from 'vue'
import VCalendar from 'v-calendar';
import Multiselect from 'vue-multiselect'

Vue.use(VCalendar, {
  componentPrefix: 'vc',
  locales: {
    'pt-PT': {
      firstDayOfWeek: 1,
      masks: {
        L: 'YYYY-MM-DD',
        input : 'YYYY-MM-DD'
      }
    }
  }
});

export default {
    data() {
        return {
            isprice : window.localStorage.getItem('is_price') == '1' ? true : false,
            detail : [],
            produkList : [],
            transaksiSelected : [],
            jenis_pembayaran: '',
            url : '',
            wilayah_penjualan : '',
            jenis_transaksi : 'penjualan',
            produkDiterima : [],
            kurs_usd : 0,
            bodyRender : true,
            pajak : 0,
            tax : [],
            biaya_lain : [],
            dibayar: 0,
            dibayar_idr : 0,
            akan_dibayar: 0,
            akan_dibayar_idr : 0,
            done : false,
            siteUrl : window.location.href.substr(0, window.location.href.indexOf('#')),
            disableIdr : true,
            disableUsd : true,
            tipe : (this.$route.params.tipe_transaksi == 'pemesanan' || this.$route.params.tipe_transaksi == 'packing') ? 'transaksi' : 'progress',
            tanggal_pembayaran : '',
            akunList: [],
            akunBayarList: [],
            akun_bayar: '',
        }
    },
    mounted() {
        this.id_transaksi_pembayaran = this.$route.params.id_transaksi;
        this.init();
    },
    methods: {
        init: function() {
            //get faktur
            this.$root.is_loading = true
            this.$http.get("Transaksi/getDetailPembayaran/"+this.id_transaksi_pembayaran).then(result => {
			    if(result.data.code == '00') {
                    alert('Gagal mengambil detail')
                }
                else {
                    this.detail = result.data.detail.detail;
                    this.transaksiSelected = result.data.detail.transaksiList
                    this.produkList = result.data.detail.produkList
                    this.biaya_lain = result.data.detail.biayaLain
                    this.wilayah_penjualan = this.detail.wilayah_pembayaran
                    this.dibayar = this.detail.dibayar
                    this.dibayar_idr = this.detail.dibayar_idr
                    this.kurs_usd = this.detail.kurs_usd
                    if(this.wilayah_penjualan == '0'){
                        this.disableUsd = false
                        this.disableIdr = true
                    }else if(this.wilayah_penjualan == '1'){
                        this.disableUsd = true
                        this.disableIdr = false
                    }
                }
                this.$root.is_loading = !this.$root.is_loading;
			}, error => {
                this.$root.is_loading = !this.$root.is_loading;
				console.log('gk ok')
				context.errors = errors;
            });

            //Get Coa LIst
            this.$http.post("Datalist/getCoa").then(result => {
			    if(result.data.code == '00') {
                    alert('failed get coa')
                }
                else {
                    this.akunList = result.data.detail;
                    this.akunBayarList = this.filterArr(this.akunList,'id_kategori','3');
                    // this.akunJualList = this.filterArr(this.akunList,'id_kategori','13')
                }
			}, error => {
				console.log('gk ok')
				context.errors = errors;
            });
        },
        currencyFormat: function(val){
            return this.$parent.currencyFormat(val)
        },
        MoneyCallback(x) {
            return x.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        goTo: function(paths) {
            this.$router.push({ path : paths })
            var $path = window.location.href.split('/');
            this.isActive = this.$route.path;
            // this.$router.go();
        },
        goBack: function() {
            this.$router.go(-1)
        },
        submitPembayaran: function() {

            if(this.akun_bayar == ''){
                this.$parent.toastr = {
                    title : 'Warning',
                    message: 'Tolong pilih akun bayar !',
                    type : 'warning'
                }
                return false
            }

            if(this.tanggal_pembayaran == '' || this.tanggal_pembayaran == null){
                this.$parent.toastr = {
                    title : 'Warning',
                    message: 'Masukkan tanggal pembayaran !',
                    type : 'warning'
                }
                return false
            }

            if(!confirm('Pastikan jumlah pembayaran sudah sesuai !')){
                return false
            }

            var formsub = new FormData()
            var objThis = this

            formsub.append('akun_bayar',this.akun_bayar);
            formsub.append('akan_dibayar',this.akan_dibayar);
            formsub.append('akan_dibayar_idr',this.akan_dibayar_idr);
            formsub.append('jenis_transaksi',this.jenis_transaksi);
            formsub.append('outstanding',(this.total_semua));
            formsub.append('outstanding_idr',(this.total_semua_idr));
            var islunas = (this.total_semua_idr <= 0 && this.total_semua <= 0) ? 1 : 0;
            formsub.append('is_lunas',islunas);
            formsub.append('tanggal_pembayaran',this.formatDate(this.tanggal_pembayaran));

            this.$http.post("Transaksi/updatePayment/"+this.id_transaksi_pembayaran, formsub).then(result => {
                if(result.data.code == '01') {
                    this.$parent.toastr = {
                        title : 'Success',
                        message: 'Transaksi berhasil di update !',
                        type : 'success'
                    }
                    this.$nextTick(function(){
                        this.$router.go(-1)
                    });
                }
                else {
                    this.$parent.toastr = {
                        title : 'Error',
                        message: 'Transaksi gagal silahkan hubungi operator !',
                        type : 'error'
                    }                    
                }
			}, error => {
				console.log('gk ok')
					context.errors = errors;
            });
            
        },
        updateTanggalPembayaran() {
            if(this.tanggal_pembayaran == ''){
                this.$parent.toastr = {
                    title : 'Warning',
                    message: 'Masukkan tanggal pembayaran !',
                    type : 'warning'
                }
                return false
            }

            if(!confirm('Yakin mau mengubah tanggal pembayaran? ')){
                return false
            }

            var formsub = new FormData()
            var objThis = this

            formsub.append('tanggal_pembayaran',this.formatDate(this.tanggal_pembayaran));

            this.$http.post("Transaksi/updateTanggalPembayaran/"+this.id_transaksi_pembayaran, formsub).then(result => {
                if(result.data.code == '01') {
                    this.$parent.toastr = {
                        title : 'Success',
                        message: 'Transaksi berhasil di update !',
                        type : 'success'
                    }
                    this.$nextTick(function(){
                        this.$router.go(-1)
                    });
                }
                else {
                    this.$parent.toastr = {
                        title : 'Error',
                        message: 'Transaksi gagal diupdate silahkan hubungi operator !',
                        type : 'error'
                    }                    
                }
			}, error => {
				console.log('gk ok')
					context.errors = errors;
            });
        },
        formatDate(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return [year, month, day].join('-');
        },
        
        getDibayarIdr: function() {
            this.akan_dibayar_idr = (this.akan_dibayar * this.kurs_usd).toFixed(2)
        },
        getDibayarUsd: function() {
            if(this.disableUsd){
                this.akan_dibayar = 0
            }else{
                this.akan_dibayar = (this.akan_dibayar_idr/this.kurs_usd).toFixed(2);
            }
        },
        biayaIconCallback: function(jenis) {
            if(jenis == 'percentage') {
                return '%'
            }else if(jenis == 'idr') {
                return 'IDR'
            }else if(jenis == 'usd') {
                return 'USD'
            }
        },
        returnItem: function(id_transaksi_produk,id_transaksi_progress) {
            if(!confirm('Kamu yakin mau me-return produk ini?')){
                return false
            }
            
            this.$http.get('Transaksi/returnItem/'+id_transaksi_produk+'/'+id_transaksi_progress).then( result => {
                if(result.data.code == '01') {
                    this.$parent.toastr = {
                        title : 'Success',
                        message: 'Produk berhasil dikembalikan !',
                        type : 'success'
                    }
                    this.$nextTick(function(){
                        this.init()
                    });
                }else {
                    this.$parent.toastr = {
                        title : 'Error',
                        message: 'Produk gagal di kembalikan !',
                        type : 'error'
                    }
                }
            })
        },
        filterArr: function(array,prop,value) {
            var filtered = [];
            for(var i = 0; i < array.length; i++){
                if(array[i][prop] == value){
                    filtered.push(array[i])
                }
            }    
            return filtered;
        },
    },
    components: {
        Multiselect
    },
    watch: {
    
    },
    computed: {
        total_semua : function() {
            var totals = 0;
            if(this.disableUsd){
                return totals
            }else {
                let that = this
                this.produkList.forEach(function(item, index){
                    totals = parseFloat(item.harga_total) + totals
                })
                var bayar = this.akan_dibayar
                if(bayar == ''){
                    bayar = 0
                }
                var telah_bayar = this.dibayar
                if(telah_bayar == '') {
                    telah_bayar = 0
                }

                var totalPajak = totals
                if(this.biaya_lain.length > 0){
                    this.biaya_lain.forEach(function(it,ind){
                        var valuebiaya = 0
                        if(it.jenis_biaya == 'percentage') {
                            valuebiaya = (it.jumlah_biaya/100) * totals
                        }else if(it.jenis_biaya == 'idr') {
                            valuebiaya = it.jumlah_biaya/that.kurs_usd
                        }else if(it.jenis_biaya == 'usd') {
                            valuebiaya = it.jumlah_biaya
                        }
                        totalPajak = totalPajak + valuebiaya
                    })
                }
                return (totalPajak - parseFloat(bayar) - parseFloat(telah_bayar)).toFixed(2)
            }
        },
        total_semua_idr : function() {
            // if(this.disableUsd){
                var totals = 0;
                this.produkList.forEach(function(item, index){
                    totals = parseFloat(item.harga_total_idr) + totals
                })
                var bayar = this.akan_dibayar_idr
                if(bayar == ''){
                    bayar = 0
                }

                var telah_bayar = this.dibayar_idr
                if(telah_bayar == '') {
                    telah_bayar = 0
                }

                var totalPajak = totals
                let that = this
                if(this.biaya_lain.length > 0){
                    this.biaya_lain.forEach(function(it,ind){
                        var valuebiaya = 0
                        if(it.jenis_biaya == 'percentage') {
                            valuebiaya = (it.jumlah_biaya/100) * totals
                        }else if(it.jenis_biaya == 'idr') {
                            valuebiaya = parseFloat(it.jumlah_biaya)
                        }else if(it.jenis_biaya == 'usd') {
                            return 'Kamu tidak bisa menggunakan jenis biaya USD pada pembayaran dalam negeri'
                        }
                        totalPajak = totalPajak + valuebiaya
                    })
                }
                return (totalPajak - parseFloat(bayar) - parseFloat(telah_bayar)).toFixed(2)
            // }else {
            //     return this.total_semua * this.kurs_usd
            // }
        },
        total_tagihan : function() {
            var totals = 0;
            if(this.disableUsd){
                return totals
            }else {
                let that = this
                this.produkList.forEach(function(item, index){
                    totals = parseFloat(that.produkList[index].harga_total) + totals
                })
               
                var totalPajak = totals
                if(this.biaya_lain.length > 0){
                    this.biaya_lain.forEach(function(it,ind){
                        var valuebiaya = 0
                        if(it.jenis_biaya == 'percentage') {
                            valuebiaya = (it.jumlah_biaya/100) * totals
                        }else if(it.jenis_biaya == 'idr') {
                            valuebiaya = it.jumlah_biaya/that.kurs_usd
                        }else if(it.jenis_biaya == 'usd') {
                            valuebiaya = it.jumlah_biaya
                        }
                        totalPajak = totalPajak + valuebiaya
                    })
                }
                return (totalPajak).toFixed(2)
            }
            
        },
        total_tagihan_idr : function() {
            var totals = 0;
            this.produkList.forEach(function(item, index){
                totals = parseFloat(item.harga_total_idr) + totals
            })

            var totalPajak = totals
            let that = this
            if(this.biaya_lain.length > 0){
                this.biaya_lain.forEach(function(it,ind){
                    var valuebiaya = 0
                    if(it.jenis_biaya == 'percentage') {
                        valuebiaya = (it.jumlah_biaya/100) * totals
                    }else if(it.jenis_biaya == 'idr') {
                        valuebiaya = parseFloat(it.jumlah_biaya)
                    }else if(it.jenis_biaya == 'usd') {
                        return 'Kamu tidak bisa menggunakan jenis biaya USD pada pembayaran dalam negeri'
                    }
                    totalPajak = totalPajak + valuebiaya
                })
            }
            return (totalPajak).toFixed(2)
        },
        sub_total_tagihan : function() {
            var totals = 0;
            this.produkList.forEach(function(item, index){
                totals = parseFloat(item.harga_total) + totals
            })
            return totals.toFixed(2)
        },
        sub_total_tagihan_idr : function() {
            if(this.disableUsd) {
                var totals = 0;
                this.produkList.forEach(function(item, index){
                    totals = parseFloat(item.harga_total_idr) + totals
                })
                return totals.toFixed(2)
            }else { 
                return this.sub_total_tagihan * this.kurs_usd
            }
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/penjualan/PaymentDetail.vue